import { createFileRoute } from '@tanstack/react-router'
import { PayrollPage } from '@/features/payroll/pages/PayrollPage'

export const Route = createFileRoute('/_app/payroll/')({
  component: PayrollPage,
})
